import { render, staticRenderFns } from "./PAYGUpgradeButton.vue?vue&type=template&id=25c2aed9&"
import script from "./PAYGUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./PAYGUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports